import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlContrato = '/service/documentos/'

class ArquivosContratoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio,
            numero: filtro.numero,
        }

        return this.conex.post(urlContrato + 'arquivosContrato/', JSON.stringify(data))
    }

    consultarLicitacao(filtro) {
        let data = {
            numero: filtro.numeroTotal,
        }

        return this.conex.post(urlContrato + 'arquivosLicitacao/', JSON.stringify(data))
    }

    consultarAnexosDetalhesAnexosAtaRegistroPreco(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }
        return this.conex.post(urlContrato + 'detalhesAnexosAtaRegistroPreco/', JSON.stringify(data))
    }

    consultarAnexosDetalhesAdvertenciaFornecedor(filtro) {
        let data = {
            sequencia: filtro.sequencia,
            cadastroGeral: filtro.cadastroGeral,
        }
        return this.conex.post(urlContrato + 'detalhesAdvertenciaFornecedor/', JSON.stringify(data))
    }

    consultarBensImoveis(filtro) {
        let data = {
            numero: filtro.numero,
        }

        return this.conex.post(urlContrato + 'arquivosBensImoveis/', JSON.stringify(data))
    }

    consultarArquivosAssinados(filtro) {
        let data = {
            exercicio: filtro.exercicioEmpenho,
            numero: filtro.numeroEmpenho,
            administracao: filtro.administracao,
        }

        return this.conex.post(urlContrato + 'arquivosAssinados/', JSON.stringify(data))
    }
}

export default ArquivosContratoService
